import { useEffect, useState, useRef, useContext } from 'react';
import '../../../styles/game/GameBoard.css';
import { useData, useSocket } from '../../../providers/SocketContext.jsx'
import { data } from 'react-router-dom';
import { useTranslation } from "react-i18next";

function ViewResults() {
    const { t } = useTranslation();
    const {isGameState} = useData()
    const socket = useSocket()
    const [isResults, setIsResults] = useState(null)
    const wrapRef = useRef(null)
    const [wrapHeight, setWrapHeight] = useState(0);
    const [textSize, setTextSize] = useState(0);
    const [dataSize, setDataSize] = useState(0);
    useEffect(() => {
        if(!socket) {
            return
        }

        const roundResultView = (res) => {
            setIsResults(res)

        }

        socket.on('roundResultData', roundResultView)

        return () => {
            socket.off('roundResultData', roundResultView)
        }
    }, [socket]) 

    useEffect(() => {

        if (wrapRef.current) {
            // Получаем высоту контейнера
            const height = wrapRef.current.getBoundingClientRect().height;
            setWrapHeight(height);

        }
        
    }, [wrapRef.current, wrapHeight, dataSize]);

    useEffect(() => {

        const resizeFont = () => {
            const width = window.innerWidth;
            if(width > 992) {
                setDataSize(108);
                setTextSize(38);
            } else if (width < 992 && width > 500) {
                setDataSize(78)
                setTextSize(26)
            } else if (width < 500) {
                setDataSize(70)
                setTextSize(23)
            }
        }
        resizeFont()
        window.addEventListener('resize', resizeFont);

        return () => {
            window.removeEventListener('resize', resizeFont);
            
            
          };
    }, [])

    const textStyle = {
        position: 'absolute',
        top: `calc(50% - ${wrapHeight ? wrapHeight / 1.5 : "0"}px)`,
        left: "50%",
        transform: `translate(-50%, -50%)`,
        fontSize: `${textSize}px`,
    }

    const multiplierText = {
        fontSize: `${dataSize}px`,
        letterSpacing: "3px",
    }

    return (
        <>
            {isGameState === 'waiting' && <div className={"data-multiplier-wrapper-view"}>
                <div className={'viewResultText'} style={textStyle}>{t("flewAway")}</div>
                <div className={"viewResultsWrap"} style={multiplierText} ref={wrapRef}>{isResults ? `${parseFloat(isResults).toFixed(2)}x` : ""}</div>
            </div>}
        </>
    )
}

export default ViewResults;